const ImagePreview = ({ preview }) => {
  return (
    <div className="image-preview">
      <img src={preview.data} alt="preview" className="image-preview" />
    </div>
  );
};

export default ImagePreview;
